import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DWS } from '@interfaces/dws';
import { WineriesService } from 'services/dws/wineries.service';
import { AdminLoginAsWineryService } from '@services/dws/admin-login-as-winery.service';
import { observe } from '@web/util/loading/loading';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoginAsWineryResolverService implements Resolve<DWS.Winery[]> {
  constructor(
    private wineriesService: WineriesService,
    private adminLoginAsWineryService: AdminLoginAsWineryService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DWS.Winery[]> {
    const privilegedToken = this.adminLoginAsWineryService.getOriginalAdminToken();
    const source$ = privilegedToken
      ? this.wineriesService.listWithToken({}, privilegedToken, 0, 999999)
      : this.wineriesService.list({}, 0, 999999);

    return observe(source$).pipe(
      map((data: DWS.Page<DWS.Winery>) => data.content || []),
      catchError(() => of([]))
    );
  }
}
